var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path10, _path11, _path12, _g3, _path13, _path14, _path15, _path16, _path17, _path18, _g4, _path19, _path20, _path21, _path22, _path23, _path24, _g5, _path25, _path26, _path27, _path28, _path29, _path30, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorageUnit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 209,
    viewBox: "0 0 151 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2_32191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.938 144.174L129.881 152.68L21.4529 152.68L17.4081 144.174L133.938 144.174Z",
    fill: "#736452",
    fillOpacity: 0.33
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4077 145.024H134.788V149.703H17.4077V145.024Z",
    fill: "#CAA98E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9595 137.795H134.788V145.025H17.4077L19.9595 137.795Z",
    fill: "url(#paint0_linear_2_32191)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.788 145.238H17.1953V144.812H134.788V145.238Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.576 138.007H20.1726V137.582H134.576V138.007Z",
    fill: "#9B571E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2075 144.955L19.7593 137.725L20.1603 137.866L17.6086 145.096L17.2075 144.955Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.575 145.031L134.363 137.588L134.788 137.576L135 145.019L134.575 145.031Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2_32191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.938 182.876L129.881 191.382L21.4529 191.382L17.4081 182.876L133.938 182.876Z",
    fill: "#736452",
    fillOpacity: 0.33
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4077 183.727H134.788V188.405H17.4077V183.727Z",
    fill: "#CAA98E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9595 174.796H134.788V183.727H17.4077L19.9595 174.796Z",
    fill: "url(#paint1_linear_2_32191)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.575 183.939H17.1953V183.514H134.575V183.939Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.576 175.008H20.1726V174.583H134.576V175.008Z",
    fill: "#9B571E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2046 183.665L19.969 174.521L20.3761 174.645L17.6117 183.788L17.2046 183.665Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.575 183.727V175.009H135V183.727H134.575Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2_32191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.938 103.56L129.881 112.065L21.4529 112.065L17.4081 103.56L133.938 103.56Z",
    fill: "#736452",
    fillOpacity: 0.33
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4077 104.41H134.788V109.088H17.4077V104.41Z",
    fill: "#CAA98E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9595 99.3066H134.362L134.788 104.41H17.4077L19.9595 99.3066Z",
    fill: "url(#paint2_linear_2_32191)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.788 104.623H17.1953V104.197H134.788V104.623Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.15 99.52H20.1726V99.0947H134.15V99.52Z",
    fill: "#9B571E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.219 104.312L19.9834 98.9961L20.3607 99.1923L17.5963 104.508L17.219 104.312Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.576 104.427L134.151 99.1111L134.575 99.0771L135 104.393L134.576 104.427Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter3_f_2_32191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.938 56.3526L129.881 64.8584L21.4529 64.8584L17.4081 56.3526L133.938 56.3526Z",
    fill: "#736452",
    fillOpacity: 0.33
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4077 57.2031H134.788V61.8813H17.4077V57.2031Z",
    fill: "#CAA98E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9595 53.8008H134.362L134.788 57.2031H17.4077L19.9595 53.8008Z",
    fill: "url(#paint3_linear_2_32191)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.788 57.4155H17.1953V56.9902H134.788V57.4155Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.15 54.0132H20.1726V53.5879H134.15V54.0132Z",
    fill: "#9B571E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.239 57.0739L20.0034 53.459L20.3412 53.7173L17.5768 57.3323L17.239 57.0739Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.579 57.2424L133.941 53.8401L134.359 53.7617L134.997 57.164L134.579 57.2424Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter4_f_2_32191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.938 17.6505L129.881 26.1562L21.4529 26.1562L17.4081 17.6505L133.938 17.6505Z",
    fill: "#736452",
    fillOpacity: 0.33
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4077 18.501H134.788V23.1792H17.4077V18.501Z",
    fill: "#DABFAA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9595 16.375H134.362L134.788 18.5014H17.4077L19.9595 16.375Z",
    fill: "#EFDDCD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.788 18.7144H17.1953V18.2891H134.788V18.7144Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.15 16.5874H20.1726V16.1621H134.15V16.5874Z",
    fill: "#9B571E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2705 18.3391L20.0349 16L20.3096 16.3247L17.5452 18.6638L17.2705 18.3391Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.583 18.5574L133.945 16.2183L134.355 16.1064L134.993 18.4455L134.583 18.5574Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2_32191",
    x: 0.408203,
    y: 127.174,
    width: 150.529,
    height: 42.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_2_32191"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2_32191",
    x: 0.408203,
    y: 165.876,
    width: 150.529,
    height: 42.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_2_32191"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2_32191",
    x: 0.408203,
    y: 86.5596,
    width: 150.529,
    height: 42.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_2_32191"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2_32191",
    x: 0.408203,
    y: 39.3525,
    width: 150.529,
    height: 42.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_2_32191"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2_32191",
    x: 0.408203,
    y: 0.650391,
    width: 150.529,
    height: 42.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_2_32191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_32191",
    x1: 76.0977,
    y1: 137.795,
    x2: 76.0977,
    y2: 145.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1DCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBEA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_32191",
    x1: 76.0977,
    y1: 176.497,
    x2: 76.0977,
    y2: 183.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1DCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBEA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_32191",
    x1: 76.0977,
    y1: 97.1802,
    x2: 76.0977,
    y2: 104.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1DCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBEA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_32191",
    x1: 76.0977,
    y1: 49.9732,
    x2: 76.0977,
    y2: 57.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1DCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEBEA4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageUnit);
export default __webpack_public_path__ + "static/media/StorageUnit.bff7ddb7b981f7f3dc1bb4fe4c532c59.svg";
export { ForwardRef as ReactComponent };